<template>
    <div class="popup">
        <div class="gyms">
            <div class="gyms__title">Locations</div>
            <ul class="gyms__list">
                <li class="gym-item"
                    v-for="gym in features"
                    :key="gym.id"
                    @click="createServiceModal(gym)"
                    >
                    <div class="gym-item__content">
                        <div class="gym-item__title">
                            {{gym.properties.name}}
                        </div>
                        <div class="gym-item__services"
                             v-for="service in JSON.parse(gym.properties.services)"
                             :key="service.id"
                             :style="{background: service.color_hex}"
                        >
                        </div>
                    </div>
                    <div class="gym-item__arrow"></div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import eventBus from '@/helpers/event-bus'
    export default Vue.extend({
        methods: {
            createServiceModal(item) {
                eventBus.$emit('createServiceModal', {features: item, coordinates: item.geometry.coordinates});
            }
        },
        props: {
            features: {
                required: true,
                type: Array,
            },
        }

    })
</script>
<style lang="sass" scoped="">
    .popup
        +medium
    .gyms
        &__title
            font-size: 14px
        &__list
            margin-top: 16px
    .gym-item
        display: flex
        align-items: center
        &:hover
            cursor: pointer
            .gym-item__arrow
                border-color: $color--dark
        &:not(:first-of-type)
            border-top: 1px solid #D7DDE1
            margin-top: 12px
            padding-top: 12px
        &__title
            +text-overflow
            max-width: 170px
            margin-right: 8px
        &__content,
        &__services
            display: flex
            justify-content: flex-start
            align-items: center
        &__content
            flex: 1
        &__services
            border-radius: 0.981413px
            width: 12px
            height: 12px
            margin-left: 4px
        &__arrow
            display: block
            width: 7px
            height: 7px
            border-top: 2px solid #B3BECA
            border-left: 2px solid #B3BECA
            transform: rotate(135deg)
            +tr(border-color .3s ease)
</style>